<div class="detailed-order-accordion">
	<div class="details">
		<div class="details-inner details-top">
			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.operation' | translate }}</h6>
				<span
					highlight
					class="value"
					[isPositive]="order()?.side === orderSideEnum.BUY"
					[isNegative]="order()?.side === orderSideEnum.SELL"
					>{{ 'ordersInfo.side.' + order()?.side | translate }}</span
				>
			</div>

			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.orderType' | translate }}</h6>
				@if (order()) {
					<span class="value">{{ order() | titleOrderType }}</span>
				}
			</div>

			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.quantity' | translate }}</h6>
				<span class="value">{{ order()?.qty | quantity }}</span>
			</div>

			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.executed' | translate }}</h6>
				<span class="value">{{ order()?.filled_qty }}</span>
			</div>

			@if (order()?.type === orderTypeEnum.STOP_LIMIT) {
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.stopPrice' | translate }}</h6>
					<span class="value">{{ order()?.stop_price | price }}</span>
				</div>

				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.limitPrice' | translate }}</h6>
					<span class="value">{{ order()?.limit_price | price }}</span>
				</div>
			} @else {
				@if (order()?.type === orderTypeEnum.LIMIT) {
					<div class="detail">
						<h6 class="title">{{ 'ordersInfo.limitPrice' | translate }}</h6>
						<span class="value">
							{{ order()?.limit_price | price }}
						</span>
					</div>
				}

				@if (order()?.type === orderTypeEnum.STOP) {
					<div class="detail">
						<h6 class="title">{{ 'ordersInfo.stopPrice' | translate }}</h6>
						<span class="value">
							{{ order()?.stop_price | price }}
						</span>
					</div>
				}

				@if (order()?.type === orderTypeEnum.MARKET) {
					<div class="detail">
						<h6 class="title">{{ 'ordersInfo.price' | translate }}</h6>
						<span class="value">
							{{ '-' }}
						</span>
					</div>
				}
			}

			@if (order()?.type === orderTypeEnum.TRAILING_STOP) {
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.stopPrice' | translate }}</h6>
					<span class="value">{{ order()?.stop_price | price }}</span>
				</div>

				@if (order()?.trail_price) {
					<div class="detail">
						<h6 class="title">{{ 'ordersInfo.trailPrice' | translate }}</h6>
						<span class="value">{{ order()?.trail_price | price }}</span>
					</div>
				}

				@if (order()?.trail_percent) {
					<div class="detail">
						<h6 class="title">{{ 'ordersInfo.trailPercent' | translate }}</h6>
						<span class="value">{{ order()?.trail_percent | percent }}</span>
					</div>
				}
			}

			@if (order()) {
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.orderDuration' | translate }}</h6>
					<span class="value">
						{{
							'ordersInfo.terms.' + (order()?.time_in_force | titleOrderTerm: order()?.extended_hours)
								| translate
						}}
					</span>
				</div>
			}

			@if (order() && isOrderFilled) {
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.averageExecutedPrice' | translate }}</h6>
					<span class="value">{{ order()?.filled_avg_price | price }}</span>
				</div>
			}
		</div>

		@if (order()?.profit_cash || order()?.profit_percent) {
			<div class="details-inner details-center">
				<div class="detail">
					<h6 class="title">
						{{ 'ordersInfo.profitability' | translate }}
					</h6>
					@if (order()) {
						<div>
							<span
								highlight
								class="value"
								[isPositive]="(order()?.profit_cash ?? 0) > 0"
								[isNegative]="(order()?.profit_cash ?? 0) < 0"
								[isNeutral]="!order()?.profit_cash"
							>
								{{ order()?.profit_cash | profit: 'dollar' }}
							</span>

							<span
								highlight
								class="value"
								[isPositive]="(order()?.profit_percent ?? 0) > 0"
								[isNegative]="(order()?.profit_percent ?? 0) < 0"
								[isNeutral]="!order()?.profit_percent"
							>
								({{ order()?.profit_percent | profit: 'percent' }})
							</span>
						</div>
					}
				</div>
			</div>
		}

		<div class="details-inner commision">
			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.brokerCommission' | translate }}</h6>
				<span class="value">{{ order()?.commission_final | price }}</span>
			</div>
		</div>

		<div class="details-inner details-bottom">
			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.placed' | translate }}</h6>
				<span class="value">
					{{ order()?.submitted_at ? (order()?.submitted_at | date: 'dd.MM.yyyy HH:mm:ss') : '-' }}
				</span>
			</div>

			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.updated' | translate }}</h6>
				<span class="value">
					{{ order()?.updated_at ? (order()?.updated_at | date: 'dd.MM.yyyy HH:mm:ss') : '-' }}
				</span>
			</div>

			@if (isOrderFilled) {
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.filled' | translate }}</h6>
					<span class="value">
						{{ order()?.filled_at ? (order()?.filled_at | date: 'dd.MM.yyyy HH:mm:ss') : '-' }}
					</span>
				</div>
			}

			@if (isOrderCanceled) {
				<div class="detail">
					<h6 class="title">{{ 'ordersInfo.canceled' | translate }}</h6>
					<span class="value">
						{{ order()?.canceled_at ? (order()?.canceled_at | date: 'dd.MM.yyyy HH:mm:ss') : '-' }}
					</span>
				</div>
			}

			<div class="detail">
				<h6 class="title">{{ 'ordersInfo.orderId' | translate }}</h6>
				<div class="right">
					<span class="value">{{ order()?.id || '-' }}</span>
					@if (order()?.id) {
						<tui-icon
							class="copy-icon"
							icon="@tui.copy"
							[clipboard]="order()?.id"
						/>
					}
				</div>
			</div>
		</div>
	</div>
</div>
